<div class="dialog-container">
  <div class="dialog-header">
    <h2 mat-dialog-title>{{ dialogTitle }}</h2>
    <button mat-icon-button (click)="onCancel()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  
      <mat-dialog-content>
        <form [formGroup]="moduleForm" class="module-form">
          <div class="form-row">
            <mat-form-field appearance="outline" class="half-width">
              <mat-label>Module Name *</mat-label>
              <input matInput 
                     formControlName="name" 
                     placeholder="Enter module name"
                     [readonly]="isReadOnly">
              @if (moduleForm.get('name')?.hasError('required')) {
                <mat-error>Module name is required</mat-error>
              }
              @if (moduleForm.get('name')?.hasError('serverError')) {
                <mat-error>{{ moduleForm.get('name')?.getError('serverError') }}</mat-error>
              }
            </mat-form-field>
            <mat-form-field appearance="outline" class="half-width">
              <mat-label>Slug *</mat-label>
              <input matInput 
                     formControlName="slug" 
                     placeholder="Enter module slug"
                     [readonly]="isReadOnly">
              @if (moduleForm.get('slug')?.hasError('required')) {
                <mat-error>Module slug is required</mat-error>
              }
              @if (moduleForm.get('slug')?.hasError('serverError')) {
                <mat-error>{{ moduleForm.get('slug')?.getError('serverError') }}</mat-error>
              }
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Description</mat-label>
              <textarea matInput 
                        formControlName="description" 
                        placeholder="Enter module description"
                        rows="3"
                        [readonly]="isReadOnly"></textarea>
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field appearance="outline" class="half-width">
              <mat-label>Icon</mat-label>
              <input matInput 
                     formControlName="icon" 
                     placeholder="Enter icon name (e.g., dashboard, settings)"
                     [readonly]="isReadOnly">
            </mat-form-field>
            <mat-form-field appearance="outline" class="half-width">
              <mat-label>Color</mat-label>
              <input matInput 
                     formControlName="color" 
                     placeholder="Enter color (e.g., #1976d2)"
                     [readonly]="isReadOnly">
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field appearance="outline" class="half-width">
              <mat-label>Version</mat-label>
              <input matInput 
                     formControlName="version" 
                     placeholder="Enter version (e.g., 1.0.0)"
                     [readonly]="isReadOnly">
            </mat-form-field>
            <mat-form-field appearance="outline" class="half-width">
              <mat-label>Status</mat-label>
              <mat-select formControlName="status" [disabled]="isReadOnly">
                <mat-option value="active">Active</mat-option>
                <mat-option value="inactive">Inactive</mat-option>
                <mat-option value="maintenance">Maintenance</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Type</mat-label>
              <mat-select formControlName="type" [disabled]="isReadOnly">
                <mat-option value="">Select Type</mat-option>
                <mat-option value="Core System">Core System</mat-option>
                <mat-option value="Facility Management">Facility Management</mat-option>
                <mat-option value="Operations">Operations</mat-option>
                <mat-option value="Services">Services</mat-option>
                <mat-option value="Compliance">Compliance</mat-option>
                <mat-option value="Business">Business</mat-option>
                <mat-option value="Specialized">Specialized</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          @if (!isReadOnly) {
            <div class="form-row checkbox-row">
              <mat-checkbox formControlName="isCore">
                Core Module
              </mat-checkbox>
            </div>
          }
        </form>
      </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">
      <mat-icon>close</mat-icon>
      {{ isReadOnly ? 'Close' : 'Cancel' }}
    </button>
    
    @if (!isReadOnly) {
      <button mat-raised-button 
              color="primary" 
              (click)="onSave()"
              [disabled]="moduleForm.invalid || isLoading">
        @if (!isLoading) {
          <mat-icon>{{ data.mode === 'create' ? 'add' : 'save' }}</mat-icon>
        }
        @if (isLoading) {
          <mat-spinner diameter="20"></mat-spinner>
        }
        {{ data.mode === 'create' ? 'Create' : 'Update' }}
      </button>
    }
  </mat-dialog-actions>
</div>
